import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game__end-container" }

import FooterComponent from '@/features/FooterComponent.vue';
import { isPhone } from '@/utils/responsiveHelper';
import MobileFooterComponent from '@/features/MobileFooterComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'EndLayoutComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_unref(isPhone)())
      ? (_openBlock(), _createBlock(MobileFooterComponent, {
          key: 0,
          location: 'end'
        }))
      : (_openBlock(), _createBlock(FooterComponent, {
          key: 1,
          location: 'end'
        }))
  ], 64))
}
}

})